import { disposeMesh } from 'src/utils/object3DHelpers';
import { ComponentInteractionType, Inputs, SceneComponent } from './types';

const DEFAULT_INPUTS = {
  url: '',
  size: 1,
  onClick: () => {},
};

export class IconComponent extends SceneComponent {
  private root: any = null;

  private pivot: any = null;

  private icon: any = null;

  private clicked = false;

  inputs: Inputs = {
    ...DEFAULT_INPUTS,
  };

  events = {
    [ComponentInteractionType.CLICK]: true,
    [ComponentInteractionType.HOVER]: true,
    [ComponentInteractionType.DRAG]: false,
  };

  onInit() {
    const THREE = this.context.three;

    this.root = new THREE.Object3D();
    this.pivot = new THREE.Object3D();
    // setting the collider to add the click event
    this.outputs.collider = this.root;
    this.outputs.objectRoot = this.root;
    this.root.add(this.pivot);

    this.makeIcon();
  }

  onDestroy() {
    if (this.icon) {
      disposeMesh(this.icon);
      this.icon = null;
    }
  }

  // Called back when any inputs properties change like localPosition or localRotation
  onInputsUpdated() {
    this.onInit();
  }

  // used to fire it from outside event handler,
  // as internal handler doesn't work if outside handler is defined
  handleHover(event: any) {
    if (!this.clicked) {
      if (event.hover) {
      }
    }
  }

  handleClick() {
    if (!this.clicked) {
      // eslint-disable-next-line @typescript-eslint/no-unused-expressions
      this.inputs.onClick && this.inputs.onClick(this);
    }
    setTimeout(() => {
      this.clicked = false;
    }, 1000);
  }

  hide() {
    (this.icon.material as any).opacity = 0;
  }

  private makeIcon() {
    const THREE = this.context.three;

    if (this.icon) {
      disposeMesh(this.icon);
      this.icon = null;
    }

    const geometry: any = new THREE.PlaneGeometry(this.inputs.size, this.inputs.size);

    new THREE.TextureLoader().load(
      this.inputs.url,
      // onLoad callback
      (texture) => {
        const material: any = new THREE.MeshBasicMaterial({
          color: 'white',
          map: texture,
          transparent: true,
          opacity: 1,
          side: THREE.DoubleSide,
          depthWrite: false,
          depthTest: false,
          // polygonOffset: true,
          // polygonOffsetFactor: -5
        });

        this.icon = new THREE.Mesh(geometry, material);
        this.pivot?.add(this.icon);
      },
    );
  }

  onTick(_tickDelta: number) {
    // @ts-ignore camera exists
    const { x, y, z } = this.context.camera.parent.position;
    this.root.lookAt(x, y, z);
  }
}

export const iconComponentType = 'treedis.iconComponent';
export const makeIconComponent = () => new IconComponent();
